export default class GroupType {
  constructor (data) {
    this.id = data.id
    this.name = data.name
  }
}
